import { render, staticRenderFns } from "./new_category.vue?vue&type=template&id=a02a5f4e&scoped=true"
import script from "./new_category.vue?vue&type=script&lang=js"
export * from "./new_category.vue?vue&type=script&lang=js"
import style0 from "./new_category.vue?vue&type=style&index=0&id=a02a5f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a5f4e",
  null
  
)

export default component.exports